<ng-template [ngIf]="item.menu" [ngIfElse]="withoutMenu">
  <mat-list>
    <mat-list-item
      class="routed-items"
      (click)="item.click()"
      [tabIndex]="item.disabled() ? -1 : 1"
      [disabled]="item.disabled()"
      [matTooltip]="item.tooltip?.message | t"
      [matTooltipPosition]="item.tooltip?.position"
      [matTooltipDisabled]="item.tooltip?.disabled()"
      [matTooltipShowDelay]="item.tooltip?.showDelay"
      [matTooltipHideDelay]="item.tooltip?.hideDelay"
      [matMenuTriggerFor]="menu"
    >
      <ng-template [ngTemplateOutlet]="itemTemplate"></ng-template>
    </mat-list-item>

    <mat-menu #menu="matMenu" [xPosition]="item.menu.positionX" [yPosition]="item.menu.positionY">
      <sn-menu [items]="item.menu.items"></sn-menu>
    </mat-menu>
  </mat-list>
</ng-template>

<ng-template #withoutMenu>
  <ng-container *ngIf="isCtrlHeld">
    <mat-list>
      <mat-list-item
        class="routed-items"
        *ngIf="item.route"
        (click)="goToLink(item); $event.stopPropagation()"
        [tabIndex]="item.disabled() ? -1 : 1"
        [disabled]="item.disabled()"
        [routerLinkActive]="['mat-list-item--activated']"
        [matTooltip]="item.tooltip?.message | t"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
      >
        <ng-template [ngTemplateOutlet]="itemTemplate"></ng-template>
      </mat-list-item>

      <mat-list-item
        *ngIf="!item.route"
        (click)="goToLink(item.route?.link); $event.stopPropagation()"
        [tabIndex]="item.disabled() ? -1 : 1"
        [disabled]="item.disabled()"
        [matTooltip]="item.tooltip?.message | t"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
        [routerLinkActive]="['mat-list-item--activated']"
      >
        <ng-template [ngTemplateOutlet]="itemTemplate"></ng-template>
      </mat-list-item>
    </mat-list>
  </ng-container>

  <ng-container *ngIf="!isCtrlHeld">
    <mat-nav-list class="nav-list">
      <mat-list-item
        class="routed-items"
        *ngIf="item.route"
        (click)="item.click(); $event.stopPropagation()"
        [tabIndex]="item.disabled() ? -1 : 1"
        [disabled]="item.disabled()"
        [routerLink]="getResolvedRouteLink()"
        [replaceUrl]="item.route?.replaceUrl"
        [state]="item.route?.state"
        [skipLocationChange]="item.route?.skipLocationChange"
        [queryParams]="item.route?.queryParams"
        [queryParamsHandling]="item.route?.queryParamsHandling"
        [fragment]="item.route?.fragment"
        [preserveFragment]="item.route?.preserveFragment"
        [routerLinkActive]="['mat-list-item--activated']"
        [matTooltip]="item.tooltip?.message | t"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
      >
        <ng-template [ngTemplateOutlet]="itemTemplate"></ng-template>
      </mat-list-item>

      <mat-list-item
        class="routed-items"
        *ngIf="!item.route"
        (click)="item.click()"
        [tabIndex]="item.disabled() ? -1 : 1"
        [disabled]="item.disabled()"
        [matTooltip]="item.tooltip?.message | t"
        [matTooltipPosition]="item.tooltip?.position"
        [matTooltipDisabled]="item.tooltip?.disabled()"
        [matTooltipShowDelay]="item.tooltip?.showDelay"
        [matTooltipHideDelay]="item.tooltip?.hideDelay"
        [routerLinkActive]="['mat-list-item--activated']"
      >
        <ng-template [ngTemplateOutlet]="itemTemplate"></ng-template>
      </mat-list-item>
    </mat-nav-list>
  </ng-container>
</ng-template>

<ng-template #itemTemplate>
  <ng-template [ngIf]="item.avatar">
    <sn-avatar
      class="nav-graphics avatar"
      [src]="item.avatar.src"
      [name]="item.avatar.name"
      [value]="item.avatar.value"
      [size]="item.avatar.size"
      [initialsSize]="item.avatar.initialsSize"
      [textSizeRatio]="item.avatar.textSizeRatio"
      [bgColor]="item.avatar.bgColor"
    >
    </sn-avatar>
  </ng-template>

  <ng-template [ngIf]="item.icon">
    <sn-icon
      class="nav-graphics"
      [icon]="item.icon.icon"
      [fontSet]="item.icon.fontSet"
      [fontIcon]="item.icon.fontIcon"
      [fontIconUnicode]="item.icon.fontIconUnicode"
      [svgIcon]="item.icon.svgIcon"
    >
    </sn-icon>
  </ng-template>

  <ng-template [ngIf]="!item.secondaryLabel">
    <span mat-line matListItemLine class="fs-text-truncate">{{ item.label | t }}</span>
  </ng-template>

  <ng-template [ngIf]="item.secondaryLabel">
    <span mat-line matListItemLine>{{ item.label | t }}</span>
    <span mat-line matListItemLine>{{ item.secondaryLabel | t }}</span>
  </ng-template>

  <sn-icon-button
    class="expandButton"
    icon="keyboard_arrow_right"
    matTooltip="Expand"
    (click)="setSecondaryNavbarHidden(false); $event.stopPropagation()"
    *ngIf="!canSeeSecondaryNavbar && hasSecondaryNavbar"
  ></sn-icon-button>
</ng-template>
